export const ARTIFACT_COLS = [
    { 
        name: 'universityName', 
        displayName: 'University Name' 
    },
    { 
        name: 'totalValue', 
        displayName: 'Total Licences' 
    },
    { 
        name: 'consumedValue', 
        displayName: 'Consumed Licences' 
    },
    { 
        name: 'remainingValue', 
        displayName: 'Remaining Licences' 
    },
    { 
        name: 'approvedValue', 
        displayName: 'Approved Licences' 
    },

  
];
